import React from 'react';
import {
    message,
    Table,
    Pagination,
    Row,
    Col,
    Popconfirm,
    Spin,
} from 'antd';
import {
    getHostList,
    deleteHost,
    restartHost,
    modifyHost,
    createHostAction,
    createStatusAction,
    createSetIpListAction,
    createAddListStatusAction,
    getServerInfo,
    getHttpServerInfo,
    changeServerStatus,
    createHostListAction,
    createPageAction,
    bunchChangeStatus,
    restartWorker
} from './actions';
import {connect} from 'react-redux';
import moment from 'moment';
import AddAndModify from './addAndModify';
import AddList from './addList';
import AddWorkList from './addWorkList';

import BulkUpdate from './bulkUpdate';
import ServerInfo from './serverInfo';
import greenImg from '../../../circleGreen.png';
import redImg from '../../../circleRed.png';
import Search from './search';


class HostList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.changePageSize = this.changePageSize.bind(this);
    }

    // 页码改变后的回调
    componentDidMount() {
        this.props.getHostList(); //查询操作日志
    }

    editHost(value) {
        if (value) {
            this.props.storeHost(value);
        }
        this.props.changeStatus(1);
    }

    changeIps(b) {
        this.props.setIpList(b);
    }

    restartHost(value, attr) {
        let ipList = new Array(value);
        this.props[attr](ipList)
            .then(() => {
                this.props.getHostList();
                message.success('重启操作成功!!!');
            })
            .catch(e => {
                message.error('重启操作失败!!!');
            });
    }

    // 改变当前页
    async changePageSize(pageNumber, pageSize) {
        this.props.createPageAction({
            page: pageNumber,
            pageSize,
        });
        await this.props.getHostList();
    }

    render() {
        const selectedRowKeys = this.props.ipList;

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
            }),
            onSelect: (record, selected, selectedRows) => {
                const Ips = selectedRows.map(item => item.ip);
                this.changeIps(Ips);
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                if (selected == true) {
                    const Ips = selectedRows.map(item => item.ip);
                    this.changeIps(Ips);
                } else if (selected == false) {
                    const Ips = [];
                    this.changeIps(Ips);
                }
            },
        };
        let columns = [
            {
                title: '机器Ip',
                dataIndex: 'ip',
            },
            {
                title: '服务状态',
                dataIndex: 'status',
                key: 'status',
                render: (text, record, index) => {
                    return text ? <img src={greenImg}/> : <img src={redImg}/>;
                },
            },
            {
                title: '描述',
                dataIndex: 'description',
            },
            {
                title: '类型',
                dataIndex: 'worker.category',
                render: text => {
                    return text == '' ? text : text == 'NORMAL' ? '通用' : text == 'EV' ? '曝光' : '点击';
                },
            },
            {
                title: '机器分组ID',
                dataIndex: 'groupId',
                sorter: (a, b) => a.groupId - b.groupId,
            },
            {
                title: '顺序',
                dataIndex: 'index',
                sorter: (a, b) => a.index - b.index,
            },
            {
                title: '点击桶位置',
                dataIndex: 'worker.clickBucketIndex',
            },
            {
                title: '计费类型',
                dataIndex: 'instanceChargeType',
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                render: text => {
                    return moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '操作',
                dataIndex: 'actions',
                render: (text, record) => (
                    <div>
                        <a
                            href="javascript:;"
                            onClick={() => this.editHost(record)}
                        >
                            编辑
                        </a>
                        <span className="ant-divider"/>
                        <Popconfirm
                            title="确定删除？"
                            onConfirm={async () => {
                                await this.props.bunchChangeStatus([record.ip], 2);
                                this.props.getHostList();
                            }}
                            onCancel={this.cancel}
                            okText="确定"
                            cancelText="取消"
                            className="task_remove">
                            <a href="javascript:;">删除</a>
                        </Popconfirm>
                        <span className="ant-divider"/>
                        <Popconfirm
                            title="确定重启？"
                            onConfirm={() => this.restartHost(record.ip, 'RestartHost')}
                            onCancel={this.cancel}
                            okText="确定"
                            cancelText="取消"
                            className="task_remove">
                            <a href="javascript:;">重启服务器</a>
                        </Popconfirm>
                        <span className="ant-divider"/>
                        <Popconfirm
                            title="确定重启？"
                            onConfirm={() => this.restartHost(record.ip, 'restartWorker')}
                            onCancel={this.cancel}
                            okText="确定"
                            cancelText="取消"
                            className="task_remove">
                            <a href="javascript:;">重启worker</a>
                        </Popconfirm>
                    </div>
                ),
            }
        ];
        let {hostList, loading, pageTotal} = this.props;
        const {total, page, pageSize} = pageTotal;
        hostList = hostList.map(item => {
            item.key = item.ip;
            return item;
        });

        return (
            <div>
                <Row className="searchRow">
                    <Search/>
                </Row>
                <AddWorkList listState={this.state}/>
                <AddAndModify listState={this.state}/>
                <BulkUpdate listState={this.state}/>
                <AddList listState={this.state}/>
                <Spin spinning={loading} tip="加载中">
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={hostList}
                        bordered
                        pagination={false}
                    />
                    {total > 0 ? (
                        <Row>
                            <Col>
                                <Pagination
                                    showQuickJumper
                                    showSizeChanger
                                    pageSizeOptions={['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']}
                                    onChange={this.changePageSize}
                                    onShowSizeChange={this.changePageSize}
                                    className="ant-table-pagination"
                                    pageSize={pageSize}
                                    defaultPageSize={pageSize}
                                    current={page}
                                    total={total}
                                />
                            </Col>
                        </Row>
                    ) : null}
                </Spin>
                <ServerInfo/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.hostList.ListStatus.loading,
    hostList: state.hostList.ListHost,
    serverInfo: state.hostList.serverInfo,
    pageTotal: state.hostList.pageTotal,
    ipList: state.hostList.ipList,
});

const mapDispatchToProps = dispatch => ({
    getHostList: params => dispatch(getHostList(params)),
    deleteHost: prarms => dispatch(deleteHost(prarms)),
    RestartHost: prarms => dispatch(restartHost(prarms)),
    modifyHost: prarms => dispatch(modifyHost(prarms)),
    storeHost: param => dispatch(createHostAction(param)),
    changeStatus: status => dispatch(createStatusAction(status)),
    changeAddListStatus: status => dispatch(createAddListStatusAction(status)),
    setIpList: list => dispatch(createSetIpListAction(list)),
    getServerInfo: () => dispatch(getServerInfo()),
    getHttpServerInfo: () => dispatch(getHttpServerInfo()),
    changeServerStatus: prarms => dispatch(changeServerStatus(prarms)),
    createHostListAction: params => dispatch(createHostListAction(params)),
    createPageAction: params => dispatch(createPageAction(params)),
    bunchChangeStatus: (ids, type) => dispatch(bunchChangeStatus(ids, type)),
    restartWorker: params => dispatch(restartWorker(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HostList);



// WEBPACK FOOTER //
// ./pages/assist/hostManage/index.js